import { getToken } from './localstorage';
import { getMe } from '../api/users';

export const getCurrentUser = async () => {
  const token = getToken();

  if (!token) return null;

  const user = await getMe();

  return user;
};
